import React from "react";
export default function () {
	return (
		<svg width="200" height="200" viewBox="0 0 200 200">
			<g>
				<g>
					<path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7z" />
					<rect x="33.1" y="23.2" width="1.9" height="71.8" />
				</g>
				<g>
					<path d="M82.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S53.4,99.8,56,104.5s10.7,5.4,18,1.6S84.9,95.4,82.2,90.7z" />
					<rect x="81.1" y="23.2" width="1.9" height="71.8" />
				</g>
				<g>
					<path d="M120.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S91.4,99.8,94,104.5s10.7,5.4,18,1.6S122.9,95.4,120.2,90.7z" />
					<rect x="119.1" y="23.2" width="1.9" height="71.8" />
				</g>
				<g>
					<path d="M157.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4s10.7,5.4,18,1.6S159.9,95.4,157.2,90.7z" />
					<rect x="156.1" y="23.2" width="1.9" height="71.8" />
				</g>
				<rect x="33.1" y="23" width="124.9" height="10" />
				<rect x="82" y="37" width="114" height="10" />
			</g>
			<g>
				<g>
					<path d="M195.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4s10.7,5.4,18,1.6S197.9,95.4,195.2,90.7z" />
					<rect x="194.1" y="23.2" width="1.9" height="71.8" />
				</g>
				<rect x="137" y="23" width="59" height="10" />
			</g>
		</svg>
	)
};